<div class="card-layer collapse-card-layer" [class.mobile]="isMobile()">
  @if (location() && !location()?.NextLayerIsEquipment) {
    <nz-collapse>
      @for (child of location()?.children; track child.objectID) {
        <nz-collapse-panel
          [nzHeader]="headerTpl"
          [nzActive]="panelExpand()"
          [nzDisabled]="child.children.length === 0"
        >
          <app-collapse-sidebar
            [location]="child"
            [selectedAssetId]="selectedAssetId()"
            [selectedSensorId]="selectedSensorId()"
          >
          </app-collapse-sidebar>
        </nz-collapse-panel>

        <ng-template #headerTpl>
          <app-rename-card-header
            [location]="child"
            [innerWrapper]="true"
            [isEditable]="false"
            [sidebar]="true"
            class="panel"
          ></app-rename-card-header>
        </ng-template>
      }
    </nz-collapse>
  }

  @if (location() && location()?.NextLayerIsEquipment) {
    <div class="area-inner-wrapper">
      @for (eqasset of location()?.children; track eqasset.objectID) {
        <div
          class="area-asset"
          [class.activeAsset]="eqasset.objectID === selectedAssetId()"
          [routerLink]="['/asset', eqasset.objectID]"
        >
          <div class="area-inner-asset-wrapper">
            <span class="asset-border"></span>
            <div class="area-inner-inner-asset-wrapper">
              <i
                nz-icon
                [nzType]="getIconByEquipmentType(eqasset)"
                class="sensor-icon svg-icon mini-icon"
              ></i>
              <span>
                {{ eqasset.objectName }} ({{
                  eqasset.sensors ? eqasset.sensors.length : 0
                }})
              </span>
            </div>
          </div>
        </div>

        @if (eqasset.objectID === selectedAssetId()) {
          <div class="area-asset-telemetry">
            @if (eqasset.sensors && eqasset.sensors.length > 0) {
              @for (sensor of eqasset.sensors; track sensor.sensorID) {
                <div
                  class="telemetry-inner-wrapper"
                  [class.activeTelemetry]="
                    sensor.sensorID === selectedSensorId()
                  "
                  [routerLink]="['/asset', eqasset.objectID, sensor.sensorID]"
                >
                  <span class="telemetry-border"></span>
                  <span class="telemetry-name">
                    {{ sensor.sensorDisplayLabel }}
                  </span>
                </div>
              }
            }
          </div>
        }
      }
    </div>
  }
</div>
